import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';
export const $Loading = styled(CircularProgress) `
  position: absolute;
  top: 45%;
  left: 50%;
  right: 50%;
  color: ${({ theme }) => theme.colors.primary};
`;
